import PropTypes from 'prop-types';
import React from 'react';
import {
  TranslationProvider,
} from '@resy/ui-kitchen';

import ConfirmCancel from '../ConfirmCancel';
import {
  canCancel,
} from '../../utils/cancel';

const pastCutoffVerbiage = (reservation) => {
  if (canCancel(reservation)) {
    return null;
  }

  const {
    venue: {
      name,
    },
  } = reservation;

  return (
    <TranslationProvider translationKey="change_past_cutoff" translationValues={{ venueName: name }}>
      Your current reservation is past the cut-off time and cannot be changed.
    </TranslationProvider>
  );
};

const Change = ({
  confirmClick,
  confirmCtaKey,
  confirmCtaText,
  reservation,
}) => (
  <ConfirmCancel
    confirmClick={confirmClick}
    confirmCtaKey={confirmCtaKey}
    confirmCtaText={confirmCtaText}
  >
    <TranslationProvider translationKey="change_reservation_header">
      <h2>Change Reservation</h2>
    </TranslationProvider>
    {pastCutoffVerbiage(reservation)}
  </ConfirmCancel>
);

Change.propTypes = {
  confirmClick: PropTypes.func,
  confirmCtaKey: PropTypes.string,
  confirmCtaText: PropTypes.string,
  reservation: PropTypes.shape({
    change: PropTypes.shape({
      allowed: PropTypes.bool,
      date_cut_off: PropTypes.string,
    }),
    venue: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
};

Change.defaultProps = {
  confirmClick: undefined,
  confirmCtaKey: 'ok',
  confirmCtaText: 'Ok',
  reservation: undefined,
};

export default Change;
